var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoUdhaar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100.4 117.3",
    style: {
      enableBackground: "new 0 0 100.4 117.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_2_);}\r\n\t.st2{fill:url(#SVGID_3_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.0764,
    y1: 75.9807,
    x2: 99.3284,
    y2: 75.9807
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    style: {
      stopColor: "#3B0C36"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3B0C36"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75.8,36v31.4c0,2.6-0.4,5.1-1.1,7.4c-1.2,3.9-3.4,7.3-6.6,10.5c-5.2,5.1-11,7.5-17.9,7.5s-12.7-2.5-17.9-7.5 c-4.5-4.4-7-9.4-7.5-15.3c-0.1-0.8-0.1-34-0.1-34L1.1,36l0,29.7C1.1,79.9,5.8,92,15,101.5c9.3,9.6,21.1,14.5,35.2,14.5 s25.9-4.9,35.2-14.5c9.2-9.6,13.9-21.6,13.9-35.9l0-29.7L75.8,36z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.0792,
    y1: 13.1036,
    x2: 24.6382,
    y2: 13.1036
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    style: {
      stopColor: "#3B0C36"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3B0C36"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.2,21.4c2.1-2.1,3.1-4.5,3.4-7.1v-2.5c-0.3-2.7-1.4-5-3.4-7.1c-1.7-1.8-3.7-2.9-5.9-3.3H1.1V25h11.8 C16.1,25,18.9,23.8,21.2,21.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 75.7661,
    y1: 13.1036,
    x2: 99.3251,
    y2: 13.1036
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    style: {
      stopColor: "#3B0C36"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3B0C36"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M87.6,25h11.8V1.3H85.1c-2.2,0.5-4.2,1.6-5.9,3.3c-2.1,2.1-3.1,4.5-3.4,7.1v2.5c0.3,2.7,1.4,5,3.4,7.1 C81.5,23.8,84.3,25,87.6,25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoUdhaar);
export default __webpack_public_path__ + "static/media/Logo_Udhaar.8d26054ed96353180fa028a12e3add52.svg";
export { ForwardRef as ReactComponent };